export { default as FoundersFund } from '../founders-fund@2x.png';
export { default as NzGrowthCapitalPartners } from '../nz-growth-capital-partners@2x.png';
export { default as IcehouseVentures } from '../icehouse-ventures@2x.png';
export { default as Fstoppers } from '../fstoppers.png';
export { default as FastCompany } from '../fast-company.png';
export { default as TechCrunch } from '../techcrunch.png';
export { default as ShotKit } from '../shotkit.png';
export { default as SlrLounge } from '../slr-lounge.png';
